export default {
  estaCarregando: false,
  filtros: {
    situacao: [],
    modalidade_turma: [],
    situacao_turma: [],
    turma: null,
  }
}
